// extracted by mini-css-extract-plugin
module.exports = {"container":"PointsDisplay_container__3hjJQ","coinIcon":"PointsDisplay_coinIcon__3QGOE","points":"PointsDisplay_points__3Udn0"};